import Vue from 'vue'
import axios from 'axios'
import auth from "../auth";

window.axioslicense = axios.create({
  baseURL: process.env.VUE_APP_LICENSE_API_URL,
});

// var identityToken = auth.auth.getSignInUserSession().getIdToken().jwtToken;

var apikey = process.env.VUE_APP_AWS_GATEWAY_API_KEY;

window.axioslicense.defaults.headers.common = {
  // 'Authorization': 'Bearer ' + identityToken,
  'x-api-key': apikey,
}

window.axioslicense.defaults.baseURL = process.env.VUE_APP_LICENSE_API_URL;


Vue.use({
  install(Vue) {
    Vue.prototype.$axioslicense = window.axioslicense
  }
})

function authAxios() {
  // var identityToken = auth.auth.getSignInUserSession().getIdToken().jwtToken;

  Vue.prototype.$axioslicense.defaults.headers.common = {
    // 'Authorization': 'Bearer ' + identityToken,
    'x-api-key': apikey,
  }
}

export default {
  auth: auth,
  axioslicense: window.axioslicense,
  authAxios: authAxios
}
